export const getUrlPropertyType = (propertyType) => {
  //TODO: Do we redirect if propertyType is null?
  switch (propertyType) {
    case 'Single':
      return 'SingleFamily';
    case 'Townhome':
      return 'Townhome';
    case 'Condo':
      return 'Condo';
    case 'Duplex':
      return 'Duplex';
    case 'Triplex':
      return 'Triplex';
    case 'Quadplex':
      return 'QuadPlex';
    default:
      return 'unknown'
  }
}
